import UserNutritionalGoals from './UserNutritionalGoals';
import { NutritionalGoalsAction } from './utils';

export default UserNutritionalGoals;
export { NutritionalGoalsAction };
